import { Subject } from "rxjs";
import { Capacitor, Plugins, AppState } from "@capacitor/core";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

export class AppUtils {
	constructor() {}

	public static get isMobileApp() {
		return Capacitor.isNative;
	}
}
